import * as React from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { useState } from "react";
import InfoIcon from "@mui/icons-material/Info";

export default function TriggersTooltips({ branchname }) {
  const [open, setOpen] = useState(false);
  const [color, setColor] = useState("#1976d2");

  const handleTooltipClose = () => {
    setOpen(false);
    setColor("#1976d2");
  };

  const handleTooltipOpen = () => {
    if (open) {
      setOpen(false);
      setColor("#1976d2");
    } else if (branchname != null) {
      setOpen(true);
      setColor("grey");
    } else {
      setOpen(true);
      setColor("grey");
    }
  };

  return (
    <div>
      <Grid container justifyContent="center" sx={{ paddingTop: "0.3rem" }}>
        <Grid item>
          <ClickAwayListener onClickAway={handleTooltipClose}>
            <div>
              <Tooltip
                PopperProps={{
                  disablePortal: true,
                }}
                title="לא ניתן לשלם על חוב פתוח שמשוייך לסניף אחר"
                onClose={handleTooltipClose}
                open={open}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                sx={{ color: color }}
              >
                <InfoIcon onClick={handleTooltipOpen} />
              </Tooltip>
            </div>
          </ClickAwayListener>
        </Grid>
      </Grid>
    </div>
  );
}
